(function($){
  $(document).on("autocompleteopen", function (event, ui) {
    $(event.target).addClass('ui-autocomplete-input--opened');
  });

  $(document).on("autocompleteclose", function (event, ui) {
    $(event.target).removeClass('ui-autocomplete-input--opened');
  });
})(jQuery);
